import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface FlowUIState {
  isGuestDetailsExpanded: boolean;
  setIsGuestDetailsExpanded: (expanded: boolean) => void;
}

export const useFlowUIStore = create<FlowUIState>()(
  persist(
    (set) => ({
      isGuestDetailsExpanded: false,
      setIsGuestDetailsExpanded: (expanded) =>
        set({ isGuestDetailsExpanded: expanded }),
    }),
    {
      name: 'aofh-flow-ui',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
